
import { createClient } from '@supabase/supabase-js'
const supabaseUrl = 'https://qtydevnghftbunqvpyyo.supabase.co'
const supabaseKey = "sb_publishable_pmWX5FiLCQjop9LrBk5hhw_CZCKbsah"
const  supabase = createClient(supabaseUrl, supabaseKey)

export default supabase